<template>
  <div class="inventoryQueryList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        maxHeight="400"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :type="item.type"
          :params="item.params"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field == 'storageQuantity'">
              {{ scope.row[item.field] | formateQuantityToWumao(isWuMaoAccount) }}
            </span>
            <span v-else-if="item.field == 'inboundQuantity'">
              {{ scope.row[item.field] | formateQuantityToWumao(isWuMaoAccount) }}
            </span>
            <span v-else-if="item.field == 'availableQuantity'">
              {{ scope.row[item.field] | formateQuantityToWumao(isWuMaoAccount) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <el-tabs type="card" v-model="activeNameTab" class="common-tab">
      <el-tab-pane label="库存明细" name="first">
        <div class="main-content" style="padding-bottom: 20px">
          <sirui-table
            ref="siruiTableDetail"
            maxHeight="400"
            :buttonList="menuButtonDetail"
            :loading="load"
            :data="tableDataDetail"
            :paging="true"
            :reserve="false"
            :setting="false"
            :customVisible="true"
            :columns="columnListDetail"
            @chooseClick="chooseClick"
          >
            <vxe-table-column
              v-for="(item, index) in columnListDetail"
              :key="index"
              :fixed="item.fixed"
              :visible="item.visible"
              :width="item.width || 120"
              :sortable="item.sortable"
              :formatter="item.formatter"
              :field="item.field"
              :type="item.type"
              :params="item.params"
              :title="item.title ? $t(item.title) : null"
            >
              <template slot-scope="scope">
                <span v-if="item.dictType">
                  {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
                </span>
                <span v-else-if="item.format">
                  {{ scope.row[item.field] | formatTableColumn(item.format) }}
                </span>
                <span v-else-if="item.field == 'changeQuantity'">
                  {{ scope.row[item.field] | formateQuantityToWumao(isWuMaoAccount) }}
                </span>
                <span v-else-if="item.field == 'storageQuantityAfter'">
                  {{ scope.row[item.field] | formateQuantityToWumao(isWuMaoAccount) }}
                </span>
                <span v-else>{{ scope.row[item.field] }}</span>
              </template>
            </vxe-table-column>
          </sirui-table>
        </div>
      </el-tab-pane>
      <el-tab-pane name="second" label="占用明细">
        <div class="main-content" style="padding-bottom: 20px">
          <sirui-table
            ref="siruiTableDetail1"
            maxHeight="400"
            :buttonList="menuButtonDetail1"
            :loading="load"
            :data="tableDataDetail1"
            :paging="true"
            :reserve="false"
            :setting="false"
            :customVisible="true"
            :columns="columnListDetail1"
            show-footer
            :footer-method="footerMethod"
            @chooseClick="chooseClick"
          >
            <vxe-table-column
              v-for="(item, index) in columnListDetail1"
              :key="index"
              :fixed="item.fixed"
              :visible="item.visible"
              :width="item.width || 120"
              :sortable="item.sortable"
              :formatter="item.formatter"
              :field="item.field"
              :type="item.type"
              :params="item.params"
              :title="item.title ? $t(item.title) : null"
            >
              <template slot-scope="scope">
                <span v-if="item.dictType">
                  {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
                </span>
                <span v-else-if="item.format">
                  {{ scope.row[item.field] | formatTableColumn(item.format) }}
                </span>
                <span v-else>{{ scope.row[item.field] }}</span>
              </template>
            </vxe-table-column>
          </sirui-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/wareHouse/inventoryQuery';
  import DataBaseAPI from '@/api/dataBase';
  import { filterEmpty } from '@/common/js/util';
  // import MASTER_API from '@/api/masterData/company.js';
  import tableMixins from '@/common/mixins/table.js';
  // import qs from 'qs';
  // import siruiUpload from '@/components/SiruiUpload';
  // import loading from '@/common/js/load.js'; //loading
  // import InputNumber from '@/components/form-item/input-number';
  import specialDict from '@/common/js/specialDict.js';
  import XEUtils from 'xe-utils';
  import { getUserCompanyList } from '@/common/js/util';
  export default {
    name: 'inventoryQueryList',
    mixins: [tableMixins],
    components: {
      // siruiUpload,
      // InputNumber,
    },
    data() {
      return {
        query: {
          departmentCode: undefined,
          docType: undefined,
          amountFlag: null,
          quantityFlag: null,
          storageAmount: undefined,
          storageQuantity: undefined,
          status: undefined,
          contractInternalNo: undefined,
          lastBatchNo: undefined,
          originalBatchNo: undefined,
        },
        activeNameTab: 'first',
        companyList: [], //公司列表
        departmentList: [], //部门列表
        menuButtonList: [], //按钮列表
        menuButtonDetail: [], //库存明细按钮
        menuButtonDetail1: [], //占用明细按钮
        tableDataDetail: [], //库存明细信息
        tableDataDetail1: [], //占用明细信息
        batchNoDetail: null, //
        //表格显示字段
        columnList: [
          { type: 'checkbox', visible: true, width: '50' },
          {
            field: 'storageCompanyCode',
            title: 'inventoryQuery.columnList.companyCode',
            visible: true,
            width: 120,
          }, //公司代码
          {
            field: 'storageCompanyName',
            title: 'inventoryQuery.columnList.companyName',
            visible: true,
            width: 180,
          }, //公司名称
          {
            field: 'storageDepartmentCode',
            title: 'inventoryQuery.columnList.departmentCode',
            visible: true,
            width: 120,
          }, //部门代码
          {
            field: 'storageDepartmentName',
            title: 'inventoryQuery.columnList.departmentName',
            visible: true,
            width: 180,
          }, //部门名称
          {
            field: 'batchNo',
            title: 'inventoryQuery.columnList.batchNo',
            visible: true,
            width: 120,
          }, //入库批次号
          {
            field: 'storageNo',
            title: 'inventoryQuery.columnList.storageNo',
            visible: true,
            width: 120,
          }, //仓库编码
          {
            field: 'storageName',
            title: 'inventoryQuery.columnList.storageName',
            visible: true,
            width: 200,
          }, //仓库名称
          {
            field: 'productNo',
            title: 'inventoryQuery.columnList.productNo',
            visible: true,
            width: 120,
          }, //物料编码
          {
            field: 'productName',
            title: 'inventoryQuery.columnList.productDesc',
            visible: true,
            width: 120,
          }, //物料描述
          {
            field: 'productUnit',
            title: 'inventoryQuery.columnList.productUnit',
            visible: true,
            width: 120,
            dictType: 'basic_unit',
          }, //单位
          {
            field: 'storageQuantity',
            title: '库存数量',
            visible: true,
            width: 120,
            // format: 'formatQuality',
          }, //库存数量
          {
            field: 'occupationQuantity',
            title: 'inventoryQuery.columnList.occupationQuantity',
            visible: true,
            width: 120,
            format: 'formatQuality',
          }, //占用数量
          {
            field: 'inboundQuantity',
            title: '入库数量',
            visible: true,
            width: 120,
            // format: 'formatQuality',
          }, //业务入库数量
          {
            field: 'availableQuantity',
            title: '可用库存数量',
            visible: true,
            width: 120,
            // format: 'formatQuality',
          }, //可用库存数量
          {
            field: 'storagePrice',
            title: 'inventoryQuery.columnList.storagePrice',
            visible: true,
            width: 120,
            format: 'formatPrice',
          }, //库存单价
          {
            field: 'storageAmount',
            title: 'inventoryQuery.columnList.storageAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          }, //库存金额
          {
            field: 'mainBusinessCost',
            title: '已发货成本',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          }, //已发货成本
          {
            field: 'currencyName',
            title: 'inventoryQuery.columnList.currencyName',
            visible: true,
            width: 120,
          }, //币种
          {
            field: 'lastBatchNo',
            title: 'inventoryQuery.columnList.lastBatchNo',
            visible: true,
            width: 120,
          }, //上一批次号
          { field: 'originalBatchNo', title: '原始批次号', visible: true, width: 200 }, //原始批次号
          {
            field: 'docTypeName',
            title: 'inventoryQuery.columnList.docType',
            visible: true,
            width: 120,
          }, //单据类型
          { field: 'contractInternalNo', title: '合同号', visible: true, width: 120 }, //单据类型
          { field: 'carNo', title: '车牌号', visible: true, width: 120 },
          { field: 'spec', title: '规格', visible: true, width: 120 },
          { field: 'documentNo', title: '纸质单据', visible: true, width: 120 },
          { field: 'netWeight', title: '净重', visible: true, width: 120 },
          { field: 'deduct', title: '扣杂', visible: true, width: 120 },
          {
            field: 'storageStatus',
            title: '状态',
            visible: true,
            width: 80,
            dictType: 'storage_business_status',
          }, //状态
        ],
        columnListDetail: [
          {
            field: 'orderNo',
            title: 'inventoryQuery.columDetail.orderNo',
            visible: true,
            width: 120,
          }, //单据编号
          {
            field: 'moveName',
            title: 'inventoryQuery.columDetail.moveName',
            visible: true,
            width: 120,
          }, //移动类型名称
          {
            field: 'changeTime',
            title: 'inventoryQuery.columDetail.changeTime',
            visible: true,
            width: 200,
          }, //发生时间
          {
            field: 'storageQuantity',
            title: 'inventoryQuery.columDetail.storageQuantity',
            visible: true,
            width: 120,
            format: 'formatQuality',
          }, //当前库存数量
          {
            field: 'storageAmount',
            title: 'inventoryQuery.columDetail.storageAmount',
            visible: true,
            width: 120,
            format: 'formatAmountRound',
          }, //当前库存金额
          {
            field: 'changeQuantity',
            title: 'inventoryQuery.columDetail.changeQuantity',
            visible: true,
            width: 150,
            // format: 'formateQuantityToWumao',
          }, //库存变动数量
          {
            field: 'changeAmount',
            title: 'inventoryQuery.columDetail.changeAmount',
            visible: true,
            width: 150,
            format: 'formatAmountRound',
          }, //库存变动金额
          {
            field: 'mainBusinessCost',
            title: '变更前已发货成本',
            visible: true,
            width: 150,
            format: 'formatAmountRound',
          }, //变更前已发货成本
          {
            field: 'mainBusinessCostAfter',
            title: '变更后已发货成本',
            visible: true,
            width: 150,
            format: 'formatAmountRound',
          }, //变更后已发货成本
          {
            field: 'storageQuantityAfter',
            title: 'inventoryQuery.columDetail.storageQuantityAfter',
            visible: true,
            width: 200,
            // format: 'formateQuantityToWumao',
          }, //变更后业务库存数量
          {
            field: 'storageAmountAfter',
            title: 'inventoryQuery.columDetail.storageAmountAfter',
            visible: true,
            width: 200,
            format: 'formatAmountRound',
          }, //变更后业务库存金额
          {
            field: 'postDate',
            title: 'inventoryQuery.columDetail.postDate',
            visible: true,
            width: 200,
          }, //入账日期
        ],
        columnListDetail1: [
          {
            field: 'orderNo',
            title: 'inventoryQuery.columDetail.orderNo',
            visible: true,
            width: 200,
          }, //单据编号
          { field: 'moveName', title: '移动类型', visible: true, width: 120 }, //移动类型
          { field: 'changeTime', title: '发生时间', visible: true, width: 200 }, //发生时间
          {
            field: 'occupationQuantity',
            title: '占用数量',
            visible: true,
            width: 120,
            format: 'formatQuality',
          }, //占用数量
          { field: 'occupationDesc', title: '占用描述', visible: true, width: 240 }, //占用描述
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            //公司代码
            prop: 'storageCompanyCode',
            name: this.$t('inventoryQuery.search.companyName'),
            type: 'select',
            placeholder: this.$t('inventoryQuery.placeholder.companyCodePlaceholder'),
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            //部门
            prop: 'storageDepartmentCode',
            name: this.$t('inventoryQuery.search.departmentName'),
            placeholder: this.$t('inventoryQuery.placeholder.departmentCodePlaceholder'),
            type: 'select',
            relatedColumn: 'none',
            options: this.departmentList,
          },
          //物料描述
          {
            prop: 'productName',
            name: this.$t('inventoryQuery.search.productDesc'),
            type: 'input',
            placeholder: this.$t('inventoryQuery.placeholder.productDescPlaceholder'),
          },
          //仓库
          {
            prop: 'storageName',
            type: 'searchTableSpec',
            name: this.$t('inventoryQuery.search.storageName'),
            placeholder: this.$t('inventoryQuery.placeholder.storageNamePlaceholder'),
            searchType: 'warehouse',
            isMultiple: true,
          },
          //入库批次号
          {
            prop: 'batchNo',
            name: this.$t('inventoryQuery.columnList.batchNo'),
            type: 'input',
            placeholder: this.$t('inventoryQuery.placeholder.batchNoPlaceholder'),
          },
          //单据类型
          {
            prop: 'docType',
            name: this.$t('inventoryQuery.columnList.docType'),
            type: 'select',
            options: specialDict.doctTypeList,
            placeholder: this.$t('inventoryQuery.placeholder.docTypePlaceholder'),
          },
          {
            //库存金额
            type: 'selectInput',
            prop: ['amountFlag', 'storageAmount'],
            name: this.$t('inventoryQuery.search.storageAmount'),
            options: [
              { value: 1, label: this.$t('inventoryQuery.search.gt') },
              { value: 2, label: this.$t('inventoryQuery.search.lt') },
              { value: 3, label: this.$t('inventoryQuery.search.notEqual') },
              { value: 4, label: this.$t('inventoryQuery.search.equal') },
            ],
          },
          {
            //库存数量
            type: 'selectInput',
            prop: ['quantityFlag', 'storageQuantity'],
            name: this.$t('inventoryQuery.search.storageQuantity'),
            options: [
              { value: 1, label: this.$t('inventoryQuery.search.gt') },
              { value: 2, label: this.$t('inventoryQuery.search.lt') },
              { value: 3, label: this.$t('inventoryQuery.search.notEqual') },
              { value: 4, label: this.$t('inventoryQuery.search.equal') },
            ],
          },
          {
            //上一批次号
            prop: 'lastBatchNo',
            name: '上一批次号',
            type: 'input',
          },
          {
            //原始批次号
            prop: 'originalBatchNo',
            name: '原始批次号',
            type: 'input',
          },
          {
            //状态
            prop: 'storageStatus',
            name: '状态',
            type: 'dict',
            dictType: 'storage_business_status',
          },
          {
            //合同号
            prop: 'contractInternalNo',
            name: '合同号',
            type: 'input',
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
      this.getCompany();
    },
    methods: {
      getDictValue({ cellValue, column }) {
        return this.$baseRequest.getDictValueByType(column.params.name, cellValue);
      },
      //获取公司信息
      async getCompany() {
        this.companyList = await getUserCompanyList();
      },
      //获取数据
      getData() {
        let query = this.setSearchParams();
        this.$axios.post(API.GET_INVENTORY_LIST, filterEmpty(query)).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 被点击时加载详细信息
      dblclickEvent(e) {
        this.tableDataDetail = [];
        this.batchNoDetail = e.row.batchNo;
        let params = { batchNo: e.row.batchNo };
        this.$axios.post(API.INVENTORY_DETAIL, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableDataDetail = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
        this.$axios.post(API.OCCUPATION_DETAIL, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableDataDetail1 = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 查询参数整理
      setSearchParams() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
          storageNo:
            query.storageName && query.storageName[0] ? query.storageName[0].storageCode : '',
          storageName:
            query.storageName && query.storageName[0] ? query.storageName[0].storageName : '',
        });
        return filterEmpty(result);
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['occupationQuantity'].includes(column.property)) {
              let total = data
                .map((i) => i['occupationQuantity'])
                .reduce((acc, cur) => {
                  const num = this.$cal.calCommon(acc, cur, '+');
                  return num;
                }, 0);
              return this.$baseRequest.formatTableColumnForNum(total);
            }
            return null;
          }),
        ];
      },
      // 选择公司
      searchCompanyName(val) {
        this.departmentList = [];
        this.query.accruedDepartmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      getdepartmentList(companyCode) {
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((res) => {
          this.menuButtonList.push(res[0]); //主表
          this.menuButtonDetail.push(res[1]); //库存
          this.menuButtonDetail1.push(res[2]); //占用
          this.menuButtonList.push(res[3]); //主表库存调整单
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'export') {
          this.export();
        } else if (type == 'detailExport') {
          this.detailExport();
        } else if (type == 'OccupationDetailExport') {
          this.OccupationDetailExport();
        } else if (type == 'costChange') {
          this.costChange();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      searchBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.tableDataDetail = [];
        this.tableDataDetail1 = [];
        this.getData();
      },
      // 删除
      resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.tableDataDetail = [];
        this.tableDataDetail1 = [];
        this.getData();
      },
      costChange() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        let inboundIdList = [];
        if (changeList.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('inventoryQuery.msg.errorTips'),
            type: 'error',
          });
          return;
        } else {
          // let ids = changeList.forEach((item) => {
          //   inboundIdList.push(item.id);
          // });
          this.$axios.post(API.CREATE_COST_ADJUST, inboundIdList).then((res) => {
            if (0 == res.data.code) {
              let path = {
                path: '/wareHouse/costAdjustOrderAdd',
                name: 'costAdjustOrderAdd',
                meta: {
                  keepAlive: false,
                  title: '成本调整单新增',
                },
                query: {
                  isEdit: 'Y',
                  costAdjustList: res.data.data,
                },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.EXPORT_INVENTORY_LIST}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.query;
          delete params.pageNum;
          delete params.pageSize;
          params = XEUtils.serialize(params);
          var reg = new RegExp('%5B%5D', 'g');
          params = params.replace(reg, '');
          window.location.href = `${this.baseUrl}${API.EXPORT_INVENTORY_LIST}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },
      detailExport() {
        window.location.href = `${this.baseUrl}${API.EXPORT_INVENTORY_DETAIL}?${
          'batchNo=' + this.batchNoDetail
        }&access_token=${this.userInfo.access_token}`;
      },
      OccupationDetailExport() {
        window.location.href = `${this.baseUrl}${API.EXPORT_OCCUPATION_DETAIL}?${
          'batchNo=' + this.batchNoDetail
        }&access_token=${this.userInfo.access_token}`;
      },
    },
  };
</script>
